import { useOutletContext } from "react-router-dom";

import { DesktopContent, DesktopContentProps } from "./DesktopContent";
import { MobileContent } from "./MobileContent";

import { useMedia } from "@otta/search/providers/media";
import { Loading } from "@otta/search/components/Loading";

export function JobContent(): React.ReactElement | null {
  const data = useOutletContext<DesktopContentProps | undefined>();

  const desktop = useMedia({ from: "tablet" });

  if (desktop.loading || !data) {
    return <Loading />;
  }

  const {
    job,
    user,
    expandOtherJobs,
    otherJobsExpanded,
    toggleKeyboardShortcuts,
  } = data;

  if (desktop.matches) {
    return (
      <DesktopContent
        job={job}
        user={user}
        expandOtherJobs={expandOtherJobs}
        otherJobsExpanded={otherJobsExpanded}
        toggleKeyboardShortcuts={toggleKeyboardShortcuts}
      />
    );
  }
  return (
    <MobileContent
      job={job}
      user={user}
      expandOtherJobs={expandOtherJobs}
      otherJobsExpanded={otherJobsExpanded}
    />
  );
}
